module.exports = __webpack_public_path__ + "static/media/default.3dcd4b70.svg";